// 自動生成ファイル。直接編集しないこと(scripts/stamp-build-info.js が生成)。
export const BUILD_ID = 1787539730507;
